import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    ROLES: "Роли",
    NAME: "Наименование",
    NAME_REQUIRED: "Введите наименование!",
    MECHANISMS_ROLE: "Механизмы роли",
    COUNT_PERMISSIONS: "Разрешений",
    PERMISSIONS: "Разрешения",
    DESCRIPTION: "Описание",
    DELETE: "Удалить",
    ADD: "Добавить",
    CREATE: "Создать",
    NO_DATA_TO_SHOW: "Нет ролей",
    EDITING: "Редактирование",
    CREATING: "Добавление роли",
    FILTER_PLACEHOLDER: "Поиск",
    getConfirmDeleteText: (count) => `Вы уверены, что хотите удалить\n${count} ${buildCorrectGrammarText(count, [
        "выбранную роль",
        "выбранные роли",
        "выбранных ролей"
    ])}?`
};
